<template>
  <div class="page-title muted">
    <div class="container restricted">
      <div class="logo inline">
        <a href="/">
          <Logo />
        </a>
      </div>
      <h1 class="inline light">{{ title }}</h1>
    </div>
  </div>
</template>
<script>
import Logo from '@/assets/logos/article-logo-circle-white.svg';

export default {
  props: ['title'],
  components: {
    Logo,
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.page-title {
  display: table;
  background: $grey-background-color;
  width: 100%;

  .logo {
    width: 50px;
    height: 50px;
    display: table-cell;
    vertical-align: middle;
    float: none;
    padding: $giant-spacer $large-spacer $giant-spacer 0;
  }
  @media (min-width: $tablet-breakpoint) {
    .logo {
      float: left;
      margin-left: -120px;
    }
  }
  h1 {
    display: table-cell;
    vertical-align: middle;
    padding-top: $giant-spacer;
    padding-bottom: $giant-spacer;
    text-align: center;
    line-height: $header-line-height;
  }
}
</style>
